import { useState, useEffect, useRef } from 'react';
import { Button, Tree, message, Skeleton } from 'antd';
import Https from '@/https';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { TreeDataNode, TreeProps } from 'antd';
import type { PermissionItem } from '@/interface/role';

export default function SetPermission() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [permissionList, setPermissionList ] = useState<TreeDataNode[]>([]);
  const permissionListRef = useRef<PermissionItem[]>([]);
  const rolePermissionListRef = useRef<PermissionItem[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [halfCheckedKeys, setHalfCheckedKeys] = useState<React.Key[]>([]);

  const back = () => {
    navigate(-1);
    dispatch({
      type: 'POP_MENU_KEYPATH',
      payload: { keyPath: 1, selectedKeys: 1 }
    })
  }
  const getRolePermission = () => {
    Https.post({
      url: 'Api/URPM/V1/SysAuthorize/RoleMenus/List',
      data: {
        terminal: 0,
        id: location.state.roleId,
      }
    }).then(res => {
      if(res.state === 1) {
        rolePermissionListRef.current = res.data;
        getPermissionList();
      }
    })
  }

  const formatCheckedKeys = (list: PermissionItem[]) => {
    let arr: string[] = [];
    list.forEach((item: PermissionItem) => {
      if(!item.children && item.isChecked) {
        arr.push(item.id)
      } else if(item.children && item.children.length) {
        arr = arr.concat(formatCheckedKeys(item.children));
      } else if(item.children && !item.children.length && item.isChecked) {
        arr.push(item.id)
      }
    })
    return arr;
  }

  const setCheckedStatus = (id: string) => {
    for(let item of rolePermissionListRef.current) {
      if(item.id === id) {
        return true;
      }
    }
    return false;
  }

  const setSubLevelCheckedStatus = (fatherId: string, id: string) => {
    for(let item of rolePermissionListRef.current) {
      if(fatherId === item.id) {
        for(let m of item.menuPermissions) {
          if(m.id === id) {
            return true;
          }
        }
      }
    }
    return false;
  }

  const getPermissionList = () => {
    Https.post({
      url: 'Api/URPM/V1/menu/list/all',
      data: {
        applicationId: 0
      }
    }).then(res => {
      if(res.state === 1) {
        let list = [];
        for(let menu of res.data) {
          if(!menu.fatherId) {
            menu.children = [];
            menu.isChecked = setCheckedStatus(menu.id);
            list.push(menu);
          }
        }
        for(let item of list) {
          for(let menu of res.data) {
            if(item.id === menu.fatherId) {
              menu.children = menu.menuPermissions;
              menu.isChecked = setCheckedStatus(menu.id);
              for(let p of menu.menuPermissions) {
                p.menuName = p.name;
                p.isChecked = setSubLevelCheckedStatus(menu.id, p.id);
              }
              item.children.push(menu)
            }
          }
        }
        setPermissionList(list);
        permissionListRef.current = list;
        setCheckedKeys(formatCheckedKeys(permissionListRef.current));
      }
    })
  }

  const onCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
    if (Array.isArray(checkedKeys)) {
      setCheckedKeys(checkedKeys);
    }
    if (info.halfCheckedKeys) {
      setHalfCheckedKeys(info.halfCheckedKeys);
    }
  };

  const confirmPermission = () => {
    let keys = [...checkedKeys, ...halfCheckedKeys];
    let menuIds = [];
    for(let item of permissionListRef.current) {
      if(keys.includes(item.id)) {
        menuIds.push({ menuId: item.id, menuPermissionIds: []})
      }
      if(item.children) {
        for(let p of item.children) {
          if(keys.includes(p.id)) {
            let obj = { menuId: p.id, menuPermissionIds: [] } as { menuId: string, menuPermissionIds: string[]};
            for(let m of p.children) {
              if(keys.includes(m.id)) {
                obj.menuPermissionIds.push(m.id);
              }
            }
            menuIds.push(obj);
          }
        }
      }
    }

    if(menuIds.length) {
      Https.post({
        url: 'Api/URPM/V1/SysAuthorize/RoleMenus/Create',
        data: {
          terminal: 0,
          roleId: location.state.roleId,
          menuIds,
        }
      }).then(res => {
        if(res.state === 1) {
          messageApi.success('设置成功');
          setTimeout(() => {
            back();
          }, 1000)
        } else {
          messageApi.error(res.data.errorMessage || res.errorMessage || '设置失败');
        }
      })
    } else {
      messageApi.error('请选择权限');
    }
  }

  useEffect(() => {
    getRolePermission();
  }, [])

  return (
    <section className="SetPermission">
      <Button onClick={back} size="small" className="back-btn">返回</Button>
      <section>
        <span>当前角色: </span>
        <span>{location.state.roleName}</span>
      </section>
      {
        permissionList.length > 0 ?
        <section className="tree-box">
          <Tree
            fieldNames={{ title: 'menuName', key: 'id', children: 'children'}}
            checkable
            checkedKeys={checkedKeys}
            onCheck={onCheck}
            treeData={permissionList}
          />
        </section> :
        <Skeleton />
      }
      <section className="permission-btn">
        <Button onClick={back}>取消</Button>
        <Button type="primary" onClick={confirmPermission}>确定</Button>
      </section>
      { messageContextHolder }
    </section>
  )
}